import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaUser, FaBars } from "react-icons/fa";
// import PortfolioMenu from "../../header/PortfolioMenu";
import {
  Bars3BottomLeftIcon,
  UserCircleIcon,
  UserIcon,
} from "@heroicons/react/24/outline"; // or /solid for filled version
import { useDispatch } from "react-redux";
import { setAuthModalOpen } from "../../../redux/features/authModalSlice";

const Header = ({ onToggleSidebar }) => {
  const [navbar, setNavbar] = useState(false);

  useEffect(() => {
    const changeBackground = () => {
      setNavbar(window.scrollY >= 10);
    };
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  const dispatch = useDispatch();

  return (
    <header
      className={`w-full z-50 border-b border-border shadow-[0_4px_12px_rgba(255,255,255,0.1)] transition-all duration-300 ${
        navbar ? "fixed bg-black " : "absolute bg-transparent shadow-md"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/">
              <img
                src={navbar ? "/logo/logo_center.png" : "/logo/logo_center.png"}
                alt="logo"
                className="h-8"
              />
            </Link>
          </div>

          {/* Right section */}
          <div className="flex items-center space-x-4">
            <button
              onClick={() => dispatch(setAuthModalOpen(true))}
              className={`p-2 rounded-full transition-colors duration-200 ${
                navbar ? "text-redlight" : "text-reddark"
              }`}
            >
              <UserCircleIcon className="w-6 h-6" />
            </button>
            <button
              type="button"
              className={`p-2 rounded-md transition-colors duration-200 ${
                navbar ? "text-redlight" : "text-reddark"
              }`}
              aria-label="Toggle Sidebar"
              onClick={onToggleSidebar}
            >
              <Bars3BottomLeftIcon className="w-6 h-6" />
            </button>
          </div>

          {/* Navigation Menu */}
          {/* <div className="hidden lg:block">
            <PortfolioMenu />
          </div> */}
        </div>
      </div>
    </header>
  );
};

export default Header;
